var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07319c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00247e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d51931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125fba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c50a1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.66666667v-2.66666667h3.80952381v2.66666667c0 1.9047619-1.90476191 2.66666666-1.90476191 2.66666666s-1.9047619-.76190476-1.9047619-2.66666666z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.66666667v-2.66666667h3.80952381v2.66666667c0 1.9047619-1.90476191 2.66666666-1.90476191 2.66666666s-1.9047619-.76190476-1.9047619-2.66666666z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.28571429 2.46092759-3.31552663-2.84187997h1.53284665l2.66666667 1.9047619h.53056713l3.53782713-2.21114196v.87780863c0 .23048322-.12717292.4773589-.3183545.61391717l-2.34831217 1.67736584v.39064654l2.39026323 2.04879706c.35209305.30179404.15528265.79308291-.29502513.79308291-.18682961 0-.4150285-.07319312-.57072646-.18440595l-2.40849833-1.72035595h-.53056713l-3.53782713 2.21114196v-1.26432973l2.66666667-1.90476191z",
    fill: "url(#a)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.66666667 2.28571429-2.66666667-2.28571429h.38095238l2.66666667 1.9047619h.76190476l3.04761905-1.9047619v.19047619c0 .1051971-.06591797.23756046-.1588262.30392347l-2.50784047 1.79131463v.76190476l2.52329509 2.16282436c.07918193.06787023.05501592.12288992-.04710461.12288992-.1051971 0-.25639416-.04708426-.34930239-.11344728l-2.50784047-1.79131462h-.76190476l-3.04761905 1.9047619v-.38095238l2.66666667-1.9047619z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1.9047619v1.52380953h2.66666667v1.90827506c0 .20845393.16307431.37743922.38452148.37743922h.75476655c.21236536 0 .38452149-.16438293.38452149-.37743922v-1.90827506h2.67392113c.20638766 0 .37369792-.16307431.37369792-.38452149v-.75476655c0-.21236536-.16385324-.38452149-.37369792-.38452149h-2.67392113v-1.9047619h-1.52380952v1.9047619z",
    fill: "url(#a)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.28571429h3.04761905v-.38095239-1.9047619h.76190476v1.9047619.38095239h3.04761905v.76190476h-3.04761905v.38095238 1.9047619h-.76190476v-1.9047619-.38095238h-3.04761905z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.809524,
    cy: 3.047619,
    fill: "#fad051",
    mask: "url(#f)",
    rx: 1.142857,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(9.904762 3.047619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.66666667v-2.66666667h3.80952381v2.66666667c0 1.9047619-1.90476191 2.66666666-1.90476191 2.66666666s-1.9047619-.76190476-1.9047619-2.66666666z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.80952381v.76190476h-1.52380952-.76190477-1.52380952z",
    fill: "#cf142c",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 4.57142857h3.80952381v.76190476h-1.52380952-.76190477-1.52380952zm0-1.52380952h3.80952381v.76190476h-1.52380952-.76190477-1.52380952zm0-1.52380953h3.80952381v.76190477h-1.52380952-.76190477-1.52380952z",
    fill: "url(#e)",
    mask: "url(#h)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/KY.6d3e20421e3ae44fb0448284957beb5f.svg";
export { ForwardRef as ReactComponent };